import { createContext, useContext, ReactNode } from 'react';
import { useGetArTaxRulesQuery } from 'domains/Invoices/invoicesApi';

type TaxExceptionsContextType = {
  productIdsWithExceptions: string[];
};

type ProviderProps = {
  children: ReactNode;
};

export const ProductTaxExceptions = createContext<TaxExceptionsContextType>({
  productIdsWithExceptions: [],
});

export const useTaxExceptionsContext = () => useContext(ProductTaxExceptions);

export function TaxExceptionsProvider({ children }: ProviderProps) {
  const { data: taxRules = [] } = useGetArTaxRulesQuery();
  const productIdsWithExceptions = taxRules.flatMap((item) =>
    item.products.map((product) => product.product_id),
  );

  return (
    <ProductTaxExceptions.Provider
      value={{
        productIdsWithExceptions,
      }}
    >
      {children}
    </ProductTaxExceptions.Provider>
  );
}
